/**
 * Permisos de la clase en vivo.
 *
 * Se consultan tanto para decidir qué se renderiza como dentro de las acciones
 * del SDK, para que ocultar un botón nunca sea la única barrera.
 */
const isHostLike = (state) => Boolean(state?.isHost);

export const canShareScreen = (state) => {
    if (!state) return false;
    if (isHostLike(state)) return true;
    return !state.shareLocked;
};

export const canFreezeScreen = (state) => isHostLike(state);

export const canControlRecording = (state) => isHostLike(state);

export const canMuteOthers = (state) => isHostLike(state);

export const canManageParticipants = (state) => isHostLike(state);

export const canRaiseHand = (state) => Boolean(state) && !isHostLike(state);

/** Error uniforme para acciones bloqueadas por permisos. */
export const permissionError = (action = 'realizar esta acción') => (
    new Error(`No tienes permiso para ${action} en esta sesión`)
);
